import React from 'react';

const EndButton = (props) => (
  <div className="col-md-12 col-sm-12 col-xs-12 mar20 status-div' text-center">
    <button onClick={props.pushToNewUrl}>{props.endButtonText}</button>
  </div>
  );
export default EndButton;
